import { ReactNode } from "react";

interface TrustlyInfoCardProps {
  title: string;
  children: ReactNode;
  bodyClassName?: string;
}

export default function TrustlyInfoCard({ title, children, bodyClassName = "" }: TrustlyInfoCardProps) {
  return (
    <div className="flex flex-col min-w-0 w-full">
      <div className="flex items-center w-full pl-3 pr-2 lg:px-3 pt-2 pb-1.5 bg-[#eaeaea] border border-[#edf0f5] border-b-0 rounded-t-xl min-h-[26px] lg:min-h-[30px]">
        <span className="text-[10px] lg:text-xs leading-3 lg:leading-4 font-bold text-secondary uppercase">
          {title}
        </span>
      </div>
      <div
        className={`flex flex-col w-full px-3 py-4 bg-[#f6f6f7] border border-[#edf0f5] rounded-b-xl ${bodyClassName}`}>
        {children}
      </div>
    </div>
  );
}
